<template>
  <div v-if="isOpen">
    <!-- <div class="modal-overlay" @click="$emit('close-modal')"></div> -->

    <div class="modal-content">
      <div class="modal-content__container">
        <div class="flex md:items-center md:flex-row flex-col justify-between md:gap-6 md:flex-wrap">
          <ul>
            <li class="flex gap-1">
              <FormKit
                v-model="isAgreeCookie"
                type="checkbox"
                :label="$t('policy-window.is-agree-cookie')"
                name="isAgreeCookie"
                outer-class="$rest mb-[8px] formkit-disabled:opacity-50"
                wrapper-class="items-center"
                label-class="mt-[0px] pb-[7px] text-[14px]"
              />
            </li>
            <li>
              <FormKit
                v-model="isReaded"
                type="checkbox"
                name="isReaded"
                outer-class="$rest mb-[8px] formkit-disabled:opacity-50"
                wrapper-class="items-center"
                label-class="mt-[0px] pb-[7px] text-[14px]"
              >
                <template #label>
                  <div class="flex flex-wrap">
                    <span class="text-[14px]">{{ $t("policy-window.is-readed") }}</span
                    >&MediumSpace;
                    <template v-if="!policyLink.agreement">
                      <a :href="policyLink" target="_blank" class="link underline text-[14px]">
                        {{ $t("policy-window.policy-link-title") }}
                      </a>
                    </template>
                    <template v-else>
                      <a :href="policyLink.policy" target="_blank" class="link underline text-[14px]">
                        {{ $t("policy-window.privacy-policy") }}
                      </a>
                      , &nbsp;
                      <a :href="policyLink.agreement" target="_blank" class="link underline text-[14px]">
                        {{ $t("policy-window.user-agreement-and-terms") }}
                      </a>
                    </template>
                  </div>
                </template>
              </FormKit>
            </li>
          </ul>
          <BaseButton @click="$emit('accept-policy')" class="md:w-[206px] h-[58px] w-full" :disabled="!isAgreeCookie || !isReaded">
            <template #title>
              {{ $t("common.accept") }}
            </template>
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { theme } from "@/services/getSiteTheme"
import { computed, ref } from "vue"

import { isMobileApp } from "constants/mobileAppConsts"

import BaseButton from "@/components/elements/ui/BaseButton.vue"

defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
})

defineEmits({
  "close-modal": null,
  "accept-policy": null,
})

const isAgreeCookie = ref(isMobileApp)
const isReaded = ref(false)

// watch(
//   props,
//   (value) => {
//     if (value.isOpen) {
//       document.body.classList.add("modal-open");
//     } else {
//       document.body.classList.remove("modal-open");
//     }
//   },
//   { immediate: true }
// );

const policyLink = computed(() =>
  theme === "kids"
    ? {
        agreement: "/agreement-user",
        policy: "/privacy",
      }
    : "https://smartsafeschool.com/agreement/store-en.html",
)
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  overflow: hidden;
}

.modal-content {
  position: fixed;
  top: 90%;
  left: 50%;
  width: 69%;
  z-index: 1000;
  transform: translate(-50%, -50%);
  scrollbar-width: none;
  -ms-overflow-style: none;

  @apply bg-light rounded-[1.25rem];
  @media (max-width: 767px) {
    top: 85%;
    width: 90%;
  }

  &__container {
    @apply px-8 pt-8 xl:pb-[23px] pb-[100px];

    @media (max-width: 768px) {
      @apply p-6;
    }

    ::-webkit-scrollbar {
      width: 4px;
    }

    ::-webkit-scrollbar-track {
      background: #d9d9d9;
    }

    ::-webkit-scrollbar-thumb {
      background: #908f8f;
      border-radius: 7px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }

    .police__header {
      h1 {
        font-size: 42px;
      }
    }
  }

  //   &::-webkit-scrollbar {
  //     display: none;
  //   }
}
</style>
